import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { 
    url: String,
    labelField: String,
    valueField: String,
    searchField: String,
    placeholder: String
  }
  
  connect() {
    try {
      this.initializeTomSelect()
    } catch (error) {
      console.error('Tom Select initialization failed:', error)
    }
  }
  
  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
  
  initializeTomSelect() {
    const options = {
      plugins: ['remove_button'],
      valueField: this.valueFieldValue || 'id',
      labelField: this.labelFieldValue || 'name', 
      searchField: this.searchFieldValue || this.labelFieldValue || 'name',
      placeholder: this.placeholderValue || 'Select items...',
      load: (query, callback) => {
        if (!query.length) return callback()
        
        const url = this.urlValue + '?q=' + encodeURIComponent(query)
        fetch(url, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(data => {
          callback(data)
        })
        .catch(error => {
          console.error('Tom Select load error:', error)
          callback()
        })
      },
      render: {
        option: (data, escape) => {
          const label = data[this.labelFieldValue || 'name'] || data.name || data.title
          return `<div>${escape(label)}</div>`
        }
      }
    }
    
    // Load pre-populated data if available
    const preloadData = this.element.dataset.load
    if (preloadData && preloadData !== '' && preloadData !== 'null') {
      try {
        const parsed = JSON.parse(preloadData)
        if (Array.isArray(parsed) && parsed.length > 0) {
          options.options = parsed
          options.items = parsed.map(item => item[this.valueFieldValue || 'id'])
        }
      } catch (e) {
        console.warn('Failed to parse preload data:', e)
      }
    }
    
    this.tomSelect = new TomSelect(this.element, options)
    
    // Ensure the original input is hidden (Tom Select should do this automatically)
    this.element.style.display = 'none'
  }
}